export function daysBetween(startDate: Date, endDate: Date) {
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const diffInMs = startDate.getTime() - endDate.getTime();
  return diffInMs / millisecondsPerDay;
}
